import React, {useState} from 'react';
import Routes from "./Routes";
import './tailwind.css';

import 'primereact/resources/themes/nova/theme.css';
import 'primeicons/primeicons.css';


import {useUserContext} from "./context/UserContext";
import LoginPage from "./components/LoginPage";
import MainMenu from "./components/MainMenu";
import {BrowserRouter as Router} from "react-router-dom";
import {useNotificationContext} from "./context/NotificationContext";
import {Toast} from "primereact/toast";
import { isMobileDevice } from './network/constants';
import { NavigationWrapper } from './utils/navigation';

function App() {
    const { user, dispatch: userDispatch } = useUserContext();
    const { toast } = useNotificationContext();
    const [ showMenu, setShowMenu ] = useState(isMobileDevice() ? false : true);


    if(!user.info || !user.info.sessionId) {
        return (
            <LoginPage dispatch={userDispatch}/>
        )
    }

    return (
        <>
            <Toast ref={toast}/>
            <Router>
                <NavigationWrapper>
                    <div className="min-h-screen flex flex-col">
                        <div className="bg-gray-750 text-gray-200 w-full flex items-center justify-between p-4">
                            <div>
                                <img className="w-24" src={require('./images/digitech_logo.svg').default} alt="tui logo"/>
                            </div>
                            <div className="text-2xl uppercase tracking-wide">
                                Hub Console
                            </div>
                            <button className="ml-6" onClick={() => {setShowMenu(!showMenu)}}><i style={{'fontSize': '1.5rem'}} className="pi pi-fw pi-bars"></i></button>
                        </div>

                        <div className="flex flex-grow relative sm:static">
                            <div className={showMenu ? "bg-gray-700 flex-shrink-0 absolute sm:static w-full sm:w-auto min-h-full z-10" : "hidden"}>
                                <MainMenu setShowMenu={setShowMenu}/>
                            </div>
                            <div className="p-4 bg-gray-100 w-full flex-shrink">
                                <Routes />
                            </div>

                        </div>
                    </div>
                </NavigationWrapper>
            </Router>
        </>
    );
}

export default App;
